import React, { useEffect, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import api from '../../../utils/api';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // <-- this is important

import Papa from 'papaparse';


const base_url = process.env.REACT_APP_API_URL;

const formatDate = (date) => {
  return date.toLocaleDateString('en-GB').split('/').join('-');
};

const getLast7Dates = () => {
  const dates = [];
  for (let i = 7; i >= 1; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(formatDate(date));
  }
  return dates;
};

const WeeklyReportsUser = () => {
  const { user_phone } = useParams();
const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [history, setHistory] = useState({});
  const [originalHistory, setOriginalHistory] = useState({});
  const [dates, setDates] = useState(getLast7Dates());
  const [casinoHistory, setCasinoHistory] = useState({});
  const [originalCasinoHistory, setOriginalCasinoHistory] = useState({});
  const [filter, setFilter] = useState('');

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const fetchHistory = async () => {
    const auth = localStorage.getItem('admin');
    const response = await api.get(`/api/webapi/weeklyReportUser?phone=${user_phone}`, {
      headers: {
        Accept: 'application/json',
        Authorization: `${auth}`,
      },
    });

    if (response?.data.success) {
      const raw = response.data.data;
      const formatted = {};
      raw.forEach(item => {
        const sport = item.sportname;
        const date = formatDate(new Date(item.report_date));
        const profit = Number(item.total_profit);
        const loss = Number(item.total_loss);

        if (!formatted[sport]) formatted[sport] = {};
        formatted[sport][date] = { profit, loss };
      });

      setHistory(formatted);
      setOriginalHistory(formatted);
    }
  };

  const fetchCasinoHistory = async () => {
    const auth = localStorage.getItem('admin');
    const response = await api.get(`/api/webapi/weeklyReportCasinoUser?phone=${user_phone}`, {
      headers: {
        Accept: 'application/json',
        Authorization: `${auth}`,
      },
    });

    if (response?.data.success) {
      const raw = response.data.data;
      const formatted = {};

      raw.forEach(item => {
        const game = item.game;
        const date = formatDate(new Date(item.report_date));
        const profit = Number(item.total_win);
        const loss = Number(item.total_loss);

        if (!formatted[game]) formatted[game] = {};
        formatted[game][date] = { profit, loss };
      });

      setCasinoHistory(formatted);
      setOriginalCasinoHistory(formatted);
    }
  };

  const handleChange = (e) => {
    const val = e.target.value.toLowerCase();
    setFilter(val);

    const filteredHistory = Object.fromEntries(
      Object.entries(originalHistory).filter(([key]) => key.toLowerCase().includes(val))
    );

    const filteredCasino = Object.fromEntries(
      Object.entries(originalCasinoHistory).filter(([key]) => key.toLowerCase().includes(val))
    );

    setHistory(filteredHistory);
    setCasinoHistory(filteredCasino);
  };

  const calculateTotals = (data, dates) => {
    const totals = {};
    let totalProfit = 0, totalLoss = 0;
    dates.forEach(date => totals[date] = { profit: 0, loss: 0 });
    Object.values(data).forEach(item => {
      dates.forEach(date => {
        const values = item[date];
        const profit = values?.profit || 0;
        const loss = values?.loss || 0;
        totals[date].profit += profit;
        totals[date].loss += loss;
        totalProfit += profit;
        totalLoss += loss;
      });
    });
    return { totals, totalProfit, totalLoss };
  };

  const { totals: sportTotals, totalProfit: sportProfit, totalLoss: sportLoss } = calculateTotals(history, dates);
  const { totals: casinoTotals, totalProfit: casinoProfit, totalLoss: casinoLoss } = calculateTotals(casinoHistory, dates);
  const grandTotal = (sportLoss + casinoLoss) - (sportProfit + casinoProfit);
  const exportPDF = () => {
  const doc = new jsPDF();
  doc.text("Weekly Report", 14, 16);

  const tableData = [];

  Object.entries(history).forEach(([key, val]) => {
    const row = [key];
    let rowTotal = 0;
    dates.forEach(date => {
      const net = (val[date]?.profit || 0) - (val[date]?.loss || 0);
      row.push(-net);
      rowTotal += -net;
    });
    row.push(rowTotal);
    tableData.push(row);
  });

  autoTable(doc, {
    head: [["Sport", ...dates, "Total"]],
    body: tableData,
    startY: 20
  });

  doc.save("weekly_report.pdf");
};

  const exportCSV = () => {
    const csvData = [];
    Object.entries(history).forEach(([key, val]) => {
      const row = { Name: key };
      dates.forEach(date => {
        row[date] = -(val[date]?.profit || 0) + (val[date]?.loss || 0);
      });
      csvData.push(row);
    });
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "weekly_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getAdminNetStyled = (net) => {
    if (net === 0) return <span className="text-dark">0</span>;
    if (net > 0) return <span className="text-success"> {Math.abs(net)}</span>; // Admin loses
    return <span className="text-danger">{net}</span>;     // Admin gains
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchHistory();
    fetchCasinoHistory();
  }, []);


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
   <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="text-primary">Weekly Report ({dates[0]} - {dates[6]})</h1>
              </div>
              <div className="col-sm-6 text-end">
                {/* <button className="btn btn-outline-success me-2" onClick={exportCSV}>Download CSV</button> */}
                <button className="btn btn-outline-danger" onClick={exportPDF}>Download PDF</button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <input type="text" className="form-control" placeholder="Filter by name..." onChange={handleChange} value={filter} />
              </div>
              <div className="col-md-6 text-end">
                <h5>Grand Total : <span className={`badge fs-6 ${grandTotal > 0 ? 'bg-success' : grandTotal < 0 ? 'bg-danger' : 'bg-secondary'}`}>{grandTotal > 0 ? grandTotal : grandTotal < 0 ? `-${Math.abs(grandTotal)}` : '0'}</span></h5>
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid">
          <div className="card p-3">
            <h4 className="text-secondary">Sports Report</h4>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sport</th>
                    {dates.map((date, i) => <th key={i}>{date}</th>)}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(history).map(([key, data], idx) => {
                    let total = 0;
                    return (
                      <tr key={idx}>
                        <td>{key}</td>
                        {dates.map((date, i) => {
                          const net = (data[date]?.profit || 0) - (data[date]?.loss || 0);
                          total += -net;
                          return (
                            <td key={i}>{getAdminNetStyled(net)}</td>
                          );
                        })}
                        <td>{getAdminNetStyled(-total)}</td>
                      </tr>
                    );
                  })}
                  <tr className="fw-bold bg-light">
                    <td>Total</td>
                    {dates.map((date, i) => {
                      const net = sportTotals[date].profit - sportTotals[date].loss;
                      return <td key={i}>{getAdminNetStyled(net)}</td>;
                    })}
                    <td>{getAdminNetStyled(sportLoss - sportProfit)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4 className="text-secondary mt-5">Casino Report</h4>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Game</th>
                    {dates.map((date, i) => <th key={i}>{date}</th>)}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(casinoHistory).map(([key, data], idx) => {
                    let total = 0;
                    return (
                      <tr key={idx}>
                        <td>{key}</td>
                        {dates.map((date, i) => {
                          const net = (data[date]?.profit || 0) - (data[date]?.loss || 0);
                          total += -net;
                          return (
                            <td key={i}>{getAdminNetStyled(net)}</td>
                          );
                        })}
                        <td>{getAdminNetStyled(-total)}</td>
                      </tr>
                    );
                  })}
                  <tr className="fw-bold bg-light">
                    <td>Total</td>
                    {dates.map((date, i) => {
                      const net = casinoTotals[date].profit - casinoTotals[date].loss;
                      return <td key={i}>{getAdminNetStyled(net)}</td>;
                    })}
                    <td>{getAdminNetStyled(casinoLoss - casinoProfit)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="mb-5" />
      </div>
    </div>
  );
};

export default WeeklyReportsUser;
